"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importStar(require("react"));

var react_input_mask_1 = __importDefault(require("react-input-mask"));

require("./nama-input.scss");

var InputSizes;

(function (InputSizes) {
  InputSizes["big"] = "big";
  InputSizes["medium"] = "medium";
  InputSizes["small"] = "small";
  InputSizes["tiny"] = "tiny";
})(InputSizes = exports.InputSizes || (exports.InputSizes = {}));

var Input = function Input(_a) {
  var className = _a.className,
      mask = _a.mask,
      maskChar = _a.maskChar,
      formatChars = _a.formatChars,
      value = _a.value,
      onChange = _a.onChange,
      validationFunction = _a.validationFunction,
      getRef = _a.getRef,
      hideBorders = _a.hideBorders,
      inputSize = _a.inputSize,
      defaultProps = __rest(_a, ["className", "mask", "maskChar", "formatChars", "value", "onChange", "validationFunction", "getRef", "hideBorders", "inputSize"]);

  var _b = react_1.useState(true),
      pristine = _b[0],
      setPristine = _b[1];

  var getValueSize = function getValueSize(val) {
    return val ? val.toString().length : 1;
  };

  var _c = react_1.useState(getValueSize(value)),
      size = _c[0],
      setSize = _c[1];

  var inputRef = react_1.useRef(null);
  react_1.useEffect(function () {
    if (getRef && inputRef.current) {
      getRef(inputRef.current);
    }
  }, [getRef]);

  var handleChange = function handleChange(event) {
    var inputElement = event.target;
    setSize(getValueSize(inputElement.value));
    setPristine(false);

    if (validationFunction) {
      var _a = validationFunction(inputElement.value),
          valid = _a.valid,
          msg = _a.msg;

      if (!valid) {
        msg && inputElement.setCustomValidity(msg);
      } else {
        inputElement.setCustomValidity('');
      }
    }

    onChange && onChange(event);
  };

  var shouldValidate = defaultProps.type !== "text" || validationFunction !== undefined || defaultProps.required;
  var inputClass = "nama-input " + inputSize;
  if (className) inputClass += ' ' + className;
  if (pristine) inputClass += ' pristine';
  if (shouldValidate) inputClass += ' validate';
  if (hideBorders) inputClass += ' no-border';
  var customProps = {
    ref: inputRef,
    className: inputClass,
    onChange: handleChange,
    size: size
  };
  if (mask) return react_1["default"].createElement(react_input_mask_1["default"], {
    mask: mask,
    value: value,
    onChange: handleChange,
    maskChar: maskChar,
    formatChars: formatChars
  }, function (inputProps) {
    return react_1["default"].createElement("input", __assign({}, customProps, defaultProps, inputProps));
  });
  return react_1["default"].createElement("input", __assign({
    value: value
  }, customProps, defaultProps));
};

exports.Input = Input;
Input.defaultProps = {
  inputSize: InputSizes.medium
};